import { inject, Injectable } from '@angular/core';
import { Currency } from '../constants/currencies';
import { CountryService } from '../api-services/cms/services/country.service';
import { ICreateCountry } from '../api-services/cms/models/country.model';
import countries from '../../../assets/media/json/countries.json';
import countriesWithState from '../../../assets/media/json/countries-states.json';
import { Option } from '../interfaces/form-fields';

export interface CountryWithIso extends Option {
  iso?: string;
}

@Injectable({
  providedIn: 'root',
})
export class CountryStateService {
  private _countryService = inject(CountryService);

  getCountryData(input: string) {
    if (!input) return;
    const searchTerm = input.toLowerCase().trim();

    return countries.find(
      (c) => c?.iso2?.toLowerCase() === searchTerm || 
             c?.name?.toLowerCase() === searchTerm
    );
  }

  getCountryStates(selectedCountry: string): Option[] {
    const selectedCountryOption = countries.find((country) => country.name === selectedCountry);
    const selectedCountryIso = selectedCountryOption?.iso2?.toUpperCase();

    if (!selectedCountryIso) {
      return [];
    }

    const countryStateData = countriesWithState.find(
      (country) => country.iso2?.toUpperCase() === selectedCountryIso
    );

    return (countryStateData?.states || []).map((stateName) => ({
      label: stateName,
      value: stateName
    }));
  }

  getCountryCurrencyEnum(countryName: string): Currency | 0 {
    if (!countryName) return 0;
    const country = countries.find(
      c => c.name?.toLowerCase().trim() === countryName.toLowerCase().trim()
    );
    if (!country || !country.currencyCode) return 0;
    switch (country.currencyCode) {
      case 'NGN': return Currency.NGN;
      case 'USD': return Currency.USD;
      case 'GBP': return Currency.GBP;
      case 'EUR': return Currency.EUR;
      case 'ZAR': return Currency.ZAR;
      case 'GHS': return Currency.GHS;
      case 'XAF': return Currency.XAF;
      default: return 0;
    }
  }

  // If selected country doesn't exist in the CMS, it'll be added. If it exists, it'll skip
  addCountry(countryName: string): void {
    const countryData = this.getCountryData(countryName);
    if (!countryData) return;

    const payload: ICreateCountry = {
      countryName: countryData.name,
      countryCode: countryData.phoneCode,
      countryCodeList: [countryData.phoneCode],
      iso: countryData.iso2,
      currency: countryData.currencyName,
      mobileCountryCode: countryData.mcc,
      mobileCountryCodeList: [countryData.mcc]
    };

    this._countryService.createCountry(payload).subscribe();
  }
}
